// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg_LoginForm {
  min-height: 100svh;
  overflow: auto;

}

/* Design the webpage */
.contentFormLogin {
  font-family: sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
}

.block_inf_promocode {
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 3px;
  text-align: center;
  background: linear-gradient(315deg, rgb(133, 122, 8) 0%, rgba(243, 218, 132, 0.66) 100%);
  border-radius: 10px;
  padding: 10px;
  font-family: Poppins, sans-serif;
  margin-top:10px;
}

/* Design the webpage */
.contentFormLogin {
  font-family: sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Basic structure of login form */
.login-box form {


  position: relative;
  display: flex;
  flex-direction: column;
  /*height: 520px;*/

  padding: 20px 35px;
  background: #11172E;
  box-sizing: border-box;

  border-radius: 20px;
}

/*.reg{*/
/*  height:400px !important;*/
/*}*/
.login-box form:before,
.login-box form:after {
  content: '';
  position: absolute;
  left: -2px;
  top: -2px;
  background: linear-gradient(45deg,
      #2d3ca579,
      /* темный сине-фиолетовый */
      
      /* лавандовый оттенок */
      #7f6ee079
      /* глубокий синий */
    );
    border-radius: 22px;




  background-size: 400%;
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  z-index: -1;
  animation: steam 20s linear infinite;
}


form * {
  font-family: 'Poppins', sans-serif;
  color: #ffffff;
  letter-spacing: 0.5px;
  outline: none;
  border: none;
}

@keyframes steam {
  0% {
    background-position: 0 0;
  }

  50% {
    background-position: 400% 0;
  }

  100% {
    background-position: 0 0;
  }
}

.login-box h2 {
  font-size: 32px;
  font-weight: 500;
  line-height: 42px;
  margin-bottom: 20px;
  text-align: center;

  color: #fff;
  text-align: center;
}



.login-box input {
  display: block;
  height: 50px;
  width: 100%;
  background-color: #483e8440;
  border-radius: 12px;
  padding: 0 10px;
  margin-top: 15px;
  font-size: 14px;
  font-weight: 300;
  box-sizing: border-box;
  /* Добавляем box-sizing со значением border-box */

}

.password {
  color: #fff;
}

.forgotPassword {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  color: rgb(140 141 140);
  cursor: pointer;
}

.login-box form button,.button_form1 {
  margin-top: 20px;
  border-radius: 5px;
  width: 100%;
  color: white;
  padding: 15px 0;
  text-align: center;
  display: flex;
  justify-content: center;
  font-size: 20px;
  font-weight: 600;
  cursor: pointer;
  box-sizing: border-box;
  background: #4251cb;
  background-size: 400%;
  border: none;

}



@keyframes animate {
  0% {
    background-position: 0%;
  }

  100% {
    background-position: 400%;
  }
}

.login-box form button:hover {
  animation: animate 8s linear infinite;
}

.social {
  margin-top: 30px;
  display: flex;
  justify-content: center;
  gap: 30px;
}

.login-box h3 {
  text-align: center;
  margin-top: 20px;
}

.fa-vk {
  color: #597ba0;
  font-size: 20px;
}

.fa-google {
  background: conic-gradient(from -45deg, #ea4335 110deg, #4285f4 90deg 180deg, #34a853 180deg 270deg, #fbbc05 270deg) 73% 55%/150% 150% no-repeat;
  -webkit-background-clip: text;

  -webkit-text-fill-color: transparent;
}

.dot_length {
  display: block;
  margin-top: 25px;
  width: 100%;
  height: 8px;
  /*animation: glow 2s alternate infinite;*/
  border-radius: 10px;
  background-image: linear-gradient(45deg, #fb0094, #0000ff, #00ff00, #ffff00, #ff0000);
  background-size: 400%;
  background-position: 0% 50%;
  /* Adjust the position as needed */

}

@keyframes glow {
  0% {
    box-shadow: 0 0 10px rgba(0, 255, 0, 0.7);
  }

  100% {
    box-shadow: 0 0 20px rgba(0, 255, 0, 0.9);
  }
}

.dot_length:before,
.dot_length:after {
  content: '';
  position: absolute;
  left: -2px;
  top: -2px;
  background: linear-gradient(45deg, #fb0094, #0000ff, #00ff00, #ffff00, #ff0000, #fb0094,
      #0000ff, #00ff00, #ffff00, #ff0000);
  background-size: 400%;
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  z-index: -1;
  animation: steam 20s linear infinite;
}

.dot_length.enter {
  width: 60px;
}

.dop {
  display: flex;
  justify-content: center;
  gap: 8px
}

@media screen and (max-width: 1000px) {
  .login-box form {
    padding: 20px;
  }

  .dot_length {
    margin-top: 10px;
  }

  .social {
    margin-top: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/LoginForm/LoginForm.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,cAAc;;AAEhB;;AAEA,uBAAuB;AACvB;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,wFAAwF;EACxF,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,kCAAkC;AAClC;;;EAGE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;;EAEjB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;;EAEtB,mBAAmB;AACrB;;AAEA,QAAQ;AACR,6BAA6B;AAC7B,IAAI;AACJ;;EAEE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT;;;;;;;KAOG;IACD,mBAAmB;;;;;EAKrB,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,WAAW;EACX,oCAAoC;AACtC;;;AAGA;EACE,kCAAkC;EAClC,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,YAAY;AACd;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;;EAElB,WAAW;EACX,kBAAkB;AACpB;;;;AAIA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iDAAiD;;AAEnD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;;AAEd;;;;AAIA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gJAAgJ;EAChJ,6BAA6B;;EAE7B,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,yCAAyC;EACzC,mBAAmB;EACnB,qFAAqF;EACrF,qBAAqB;EACrB,2BAA2B;EAC3B,kCAAkC;;AAEpC;;AAEA;EACE;IACE,yCAAyC;EAC3C;;EAEA;IACE,yCAAyC;EAC3C;AACF;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT;yCACuC;EACvC,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".bg_LoginForm {\n  min-height: 100svh;\n  overflow: auto;\n\n}\n\n/* Design the webpage */\n.contentFormLogin {\n  font-family: sans-serif;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.block_inf_promocode {\n  color: white;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 3px;\n  text-align: center;\n  background: linear-gradient(315deg, rgb(133, 122, 8) 0%, rgba(243, 218, 132, 0.66) 100%);\n  border-radius: 10px;\n  padding: 10px;\n  font-family: Poppins, sans-serif;\n  margin-top:10px;\n}\n\n/* Design the webpage */\n.contentFormLogin {\n  font-family: sans-serif;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Basic structure of login form */\n.login-box form {\n\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  /*height: 520px;*/\n\n  padding: 20px 35px;\n  background: #11172E;\n  box-sizing: border-box;\n\n  border-radius: 20px;\n}\n\n/*.reg{*/\n/*  height:400px !important;*/\n/*}*/\n.login-box form:before,\n.login-box form:after {\n  content: '';\n  position: absolute;\n  left: -2px;\n  top: -2px;\n  background: linear-gradient(45deg,\n      #2d3ca579,\n      /* темный сине-фиолетовый */\n      \n      /* лавандовый оттенок */\n      #7f6ee079\n      /* глубокий синий */\n    );\n    border-radius: 22px;\n\n\n\n\n  background-size: 400%;\n  width: calc(100% + 4px);\n  height: calc(100% + 4px);\n  z-index: -1;\n  animation: steam 20s linear infinite;\n}\n\n\nform * {\n  font-family: 'Poppins', sans-serif;\n  color: #ffffff;\n  letter-spacing: 0.5px;\n  outline: none;\n  border: none;\n}\n\n@keyframes steam {\n  0% {\n    background-position: 0 0;\n  }\n\n  50% {\n    background-position: 400% 0;\n  }\n\n  100% {\n    background-position: 0 0;\n  }\n}\n\n.login-box h2 {\n  font-size: 32px;\n  font-weight: 500;\n  line-height: 42px;\n  margin-bottom: 20px;\n  text-align: center;\n\n  color: #fff;\n  text-align: center;\n}\n\n\n\n.login-box input {\n  display: block;\n  height: 50px;\n  width: 100%;\n  background-color: #483e8440;\n  border-radius: 12px;\n  padding: 0 10px;\n  margin-top: 15px;\n  font-size: 14px;\n  font-weight: 300;\n  box-sizing: border-box;\n  /* Добавляем box-sizing со значением border-box */\n\n}\n\n.password {\n  color: #fff;\n}\n\n.forgotPassword {\n  margin-top: 20px;\n  display: flex;\n  justify-content: center;\n  color: rgb(140 141 140);\n  cursor: pointer;\n}\n\n.login-box form button,.button_form1 {\n  margin-top: 20px;\n  border-radius: 5px;\n  width: 100%;\n  color: white;\n  padding: 15px 0;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  font-size: 20px;\n  font-weight: 600;\n  cursor: pointer;\n  box-sizing: border-box;\n  background: #4251cb;\n  background-size: 400%;\n  border: none;\n\n}\n\n\n\n@keyframes animate {\n  0% {\n    background-position: 0%;\n  }\n\n  100% {\n    background-position: 400%;\n  }\n}\n\n.login-box form button:hover {\n  animation: animate 8s linear infinite;\n}\n\n.social {\n  margin-top: 30px;\n  display: flex;\n  justify-content: center;\n  gap: 30px;\n}\n\n.login-box h3 {\n  text-align: center;\n  margin-top: 20px;\n}\n\n.fa-vk {\n  color: #597ba0;\n  font-size: 20px;\n}\n\n.fa-google {\n  background: conic-gradient(from -45deg, #ea4335 110deg, #4285f4 90deg 180deg, #34a853 180deg 270deg, #fbbc05 270deg) 73% 55%/150% 150% no-repeat;\n  -webkit-background-clip: text;\n\n  -webkit-text-fill-color: transparent;\n}\n\n.dot_length {\n  display: block;\n  margin-top: 25px;\n  width: 100%;\n  height: 8px;\n  /*animation: glow 2s alternate infinite;*/\n  border-radius: 10px;\n  background-image: linear-gradient(45deg, #fb0094, #0000ff, #00ff00, #ffff00, #ff0000);\n  background-size: 400%;\n  background-position: 0% 50%;\n  /* Adjust the position as needed */\n\n}\n\n@keyframes glow {\n  0% {\n    box-shadow: 0 0 10px rgba(0, 255, 0, 0.7);\n  }\n\n  100% {\n    box-shadow: 0 0 20px rgba(0, 255, 0, 0.9);\n  }\n}\n\n.dot_length:before,\n.dot_length:after {\n  content: '';\n  position: absolute;\n  left: -2px;\n  top: -2px;\n  background: linear-gradient(45deg, #fb0094, #0000ff, #00ff00, #ffff00, #ff0000, #fb0094,\n      #0000ff, #00ff00, #ffff00, #ff0000);\n  background-size: 400%;\n  width: calc(100% + 4px);\n  height: calc(100% + 4px);\n  z-index: -1;\n  animation: steam 20s linear infinite;\n}\n\n.dot_length.enter {\n  width: 60px;\n}\n\n.dop {\n  display: flex;\n  justify-content: center;\n  gap: 8px\n}\n\n@media screen and (max-width: 1000px) {\n  .login-box form {\n    padding: 20px;\n  }\n\n  .dot_length {\n    margin-top: 10px;\n  }\n\n  .social {\n    margin-top: 15px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
